import router from '~/core/router';
import { Promo } from '~/modules/promotion';

router.addPrivateRoutes([Promo]);
